import { render } from "./qlc-wind.vue?vue&type=template&id=3d84c80d&scoped=true"
import script from "./qlc-wind.vue?vue&type=script&lang=js"
export * from "./qlc-wind.vue?vue&type=script&lang=js"

import "./qlc-wind.vue?vue&type=style&index=0&id=3d84c80d&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d84c80d"]])

export default __exports__